enum EndMarketRole {
  RPM = "RPM",
  Reuse = "Reuse",
  Landfill = "Landfill",
  EnergyFuel = "EnergyFuel",
  Recycling = "Recycling",
}

export default EndMarketRole;
